import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getLatestImportCounts } from '../../api';

export const importsLatestCountsSlice = createGetAsyncSlice({
	name: 'ImportsLatestCounts',
	receive: true,
	request: false,
	requestHandler: getLatestImportCounts,
	retainDataOnRequest: true
});
